// Cache DOM elements and variants data at initialization
let cachedVariants = null;
let cachedAddToCartForm = null;
let cachedPriceElement = null;

// Initialize cache when DOM is ready
async function initializeCache() {
    cachedAddToCartForm = document.querySelector('form[action="/cart/add"]');
    cachedPriceElement = document.querySelector('.product__price--regular');
    const variantsJson = document.querySelector('script[type="application/json"]');
    cachedVariants = JSON.parse(variantsJson?.textContent || '[]');
}

async function actualizarVarianteSeleccionada(input) {
    const variantId = input.getAttribute('data-variant-id');
    if (!variantId || !cachedAddToCartForm) return;

    let variantInput = cachedAddToCartForm.querySelector('input[name="id"]');
    if (!variantInput) {
        variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        cachedAddToCartForm.appendChild(variantInput);
    }
    variantInput.value = variantId;

    // Update the price
    updatePrice(variantId);
}

function updatePrice(variantId) {
    if (!cachedPriceElement) return;
    
    const variant = cachedVariants?.find(v => v.id.toString() === variantId);
    if (variant) {
        cachedPriceElement.textContent = variant.price;
    }
}

// Optimize selector function with event delegation
async function id_selector() {
    const productSelectors = document.querySelectorAll("variant-picker");
    if (!productSelectors.length) return;

    // Initialize cache first
    await initializeCache();

    productSelectors.forEach(selector => {
        // Use event delegation instead of multiple listeners
        selector.addEventListener('change', (event) => {
            const radio = event.target;
            if (radio.type === 'radio') {
                const select = selector.querySelector('select[name="id"]');
                const seleccion = radio.value;
                const id_opcion = radio.getAttribute('data-index');
                
                if (select && id_opcion) {
                    cambiar_select(select, seleccion, id_opcion);
                }
            }
        });
    });
}

function cambiar_select(select, seleccion, id_opcion) {
    const optionSeleccionado = select.options[select.selectedIndex];
    const full_seleccion = optionSeleccionado.textContent.split(' / ');
    const posicion_opcion = id_opcion.replace(/\D/g, '') - 1;
    
    full_seleccion[posicion_opcion] = seleccion;
    const nueva_seleccion_txt = full_seleccion.join(' / ');

    // Use Array.from for better performance with NodeList
    Array.from(select.options).forEach(opcion => {
        opcion.selected = opcion.textContent === nueva_seleccion_txt;
    });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', id_selector);